import { ModalContext } from "app/app";
import { Icon } from "components/lib";
import { Field } from "formik";
import { useCallback, useContext } from "react";
import CurrencyInput from "react-currency-input-field";
import { useDropzone } from "react-dropzone";
import ReactSelect from "react-select";
import styles from "./styles.module.scss";

export function FieldInput(props) {
  const { modal } = useContext(ModalContext);
  const { className } = props;
  const onDrop = useCallback((file) => {
    if (!document.getElementById(props.id)) return;

    var container = new DataTransfer();

    for (var i = 0; i < file.length; i++) {
      container.items.add(file[i]);
    }

    document.getElementById(props.id).files = container.files;
    props.handleChange(container);
  }, []);

  const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop });

  return (
    <div className={`${styles.field} ${className}`}>
      {props.label && props.type !== "checkbox" && (
        <label
          htmlFor={props.id}
          style={props.strongTitle ? { fontWeight: 600 } : {}}
        >
          {props.label} {props.required && <span>*</span>}
        </label>
      )}

      {props.type === "text" && (
        <Field
          id={props.id}
          name={props.id}
          className={styles.input}
          placeholder={props.placeholder}
          onChange={props.handleChange}
          onBlur={props.handleBlur}
          defaultValue={props.defaultValue}
          style={props.halfSize ? { width: "50%" } : { width: "100%" }}
          disabled={props.disabled}
        />
      )}

      {props.type === "text_with_value" && (
        <Field
          id={props.id}
          name={props.id}
          className={styles.input}
          placeholder={props.placeholder}
          onChange={props.handleChange}
          onBlur={props.handleBlur}
          value={props.value}
          style={props.halfSize ? { width: "50%" } : { width: "100%" }}
          disabled={props.disabled}
        />
      )}

      {props.type === "multi_select_creatable" && (
        <ReactSelect
          isMulti
          name="policy"
          options={props.options}
          defaultValue={props.defaultValue}
          classNamePrefix="select"
          onChange={(event) => props.handleChange(event)}
          required
          styles={{
            container: (baseStyles, state) => ({
              ...baseStyles,
              width: "100%",
              minHeight: "50px",
              marginTop: "10px",
            }),
            control: (baseStyles, state) => ({
              ...baseStyles,
              width: "100%",
              minHeight: "50px",
              border: "solid 1.5px #e0e0e0",
              borderRadius: "10px",
            }),
          }}
        />
      )}

      {props.type === "multi_select" && (
        <ReactSelect
          isMulti
          name="policy"
          options={props.options}
          defaultValue={props.defaultValue}
          classNamePrefix="select"
          onChange={(event) => props.handleChange(event)}
          required
          styles={{
            container: (baseStyles, state) => ({
              ...baseStyles,
              width: "100%",
              minHeight: "50px",
              marginTop: "10px",
            }),
            control: (baseStyles, state) => ({
              ...baseStyles,
              width: "100%",
              minHeight: "50px",
              border: "solid 1.5px #e0e0e0",
              borderRadius: "10px",
            }),
          }}
        />
      )}

      {props.type === "phone" && (
        <Field
          id={props.id}
          name={props.id}
          className={styles.input}
          placeholder={props.placeholder}
          onChange={props.handleChange}
          onBlur={props.handleBlur}
          value={props.value}
          style={props.halfSize ? { width: "50%" } : { width: "100%" }}
          disabled={props.disabled}
        />
      )}

      {props.type === "currency" && (
        <Field
          id={props.id}
          name={props.id}
          className={styles.input}
          placeholder={props.placeholder}
          defaultValue={props.defaultValue}
          onChange={props.handleChange}
          onBlur={props.handleBlur}
          value={props.value}
          style={props.halfSize ? { width: "50%" } : { width: "100%" }}
          disabled={props.disabled}
        />
      )}

      {props.type === "currency_automatic" && (
        <Field
          id={props.id}
          name={props.id}
          placeholder={props.placeholder}
          style={props.halfSize ? { width: "50%" } : { width: "100%" }}
          disabled={props.disabled}
        >
          {({ field, form, meta }) => (
            <CurrencyInput
              id={props.id}
              name={props.id}
              defaultValue={props.defaultValue}
              className={styles.input}
              onBlur={props.handleBlur}
              onChange={props.handleChange}
              value={props.value}
              decimalsLimit={2}
              placeholder="$"
              prefix="$"
              decimalSeparator="."
              groupSeparator=","
              min={0}
            />
          )}
        </Field>
      )}

      {props.type === "date" && (
        <Field
          id={props.id}
          type="date"
          name={props.id}
          className={styles.input}
          placeholder={props.placeholder}
          defaultValue={props.defaultValue}
          onChange={props.handleChange}
          onBlur={props.handleBlur}
          style={props.halfSize ? { width: "50%" } : { width: "100%" }}
          disabled={props.disabled}
          min={props.minDate || props.min}
          max={props.maxDate || props.max || "9999-12-31"}
        />
      )}

      {props.type === "number" && (
        <Field
          id={props.id}
          type="number"
          name={props.id}
          className={styles.input}
          placeholder={props.placeholder}
          onChange={props.handleChange}
          onBlur={props.handleBlur}
          style={props.halfSize ? { width: "50%" } : { width: "100%" }}
          disabled={props.disabled}
          defaultValue={props.defaultValue}
          min={props.min}
          max={props.max}
        />
      )}

      {props.type === "area" && (
        <textarea
          id={props.id}
          name={props.id}
          className={styles.input}
          placeholder={props.placeholder}
          onChange={props.handleChange}
          onBlur={props.handleBlur}
        />
      )}

      {props.type === "upload" && (
        <div className={styles.upload} {...getRootProps()} onClick={() => {}}>
          {isDragActive ? (
            <>
              <div className={styles.uploadIcon}>
                <Icon image="arrow-down-circle" color="#d32426" size={20} />
              </div>
              <span>Drop your file</span>
            </>
          ) : (
            <>
              <div className={styles.uploadIcon}>
                <Icon image="upload" color="#d32426" size={20} />
              </div>
              <span>
                {document.getElementById(props.id) &&
                  document.getElementById(props.id).files[0] && (
                    <>
                      <span>
                        Attached:{" "}
                        {document.getElementById(props.id).files[0].name}
                      </span>
                      <br />
                    </>
                  )}
                {modal.data && modal.data.link && (
                  <>
                    <span
                      style={{
                        color: "#637381",
                        textDecoration: "none",
                        cursor: "default",
                      }}
                    >
                      Attached: {modal.data.link.split("/")[3].split("-")[1]}{" "}
                      <span
                        style={{
                          textDecoration: "none",
                          cursor: "pointer",
                        }}
                        onClick={() => window.open(modal.data.link)}
                      >
                        - View file
                      </span>
                    </span>
                    <br />
                  </>
                )}
                {props.id === "front_license" &&
                  modal.data &&
                  modal.data.front_license_link && (
                    <>
                      <span
                        style={{
                          color: "#637381",
                          textDecoration: "none",
                          cursor: "default",
                        }}
                      >
                        Attached:{" "}
                        {
                          modal.data.front_license_link
                            .split("/")[3]
                            .split("-")[1]
                        }{" "}
                        <span
                          style={{
                            textDecoration: "none",
                            cursor: "pointer",
                          }}
                          onClick={() =>
                            window.open(modal.data.front_license_link)
                          }
                        >
                          - View file
                        </span>
                      </span>
                      <br />
                    </>
                  )}
                {props.id === "back_license" &&
                  modal.data &&
                  modal.data.back_license_link && (
                    <>
                      <span
                        style={{
                          color: "#637381",
                          textDecoration: "none",
                          cursor: "default",
                        }}
                      >
                        Attached:{" "}
                        {
                          modal.data.back_license_link
                            .split("/")[3]
                            .split("-")[1]
                        }{" "}
                        <span
                          style={{
                            textDecoration: "none",
                            cursor: "pointer",
                          }}
                          onClick={() =>
                            window.open(modal.data.back_license_link)
                          }
                        >
                          - View file
                        </span>
                      </span>
                      <br />
                    </>
                  )}
                Drag & drop or{" "}
                {(modal.data && modal.data.link && (
                  <span
                    onClick={() => {
                      var elem = document.getElementById(props.id);

                      if (elem) {
                        elem.click();
                      }
                    }}
                  >
                    change
                  </span>
                )) ||
                  (props.id === "front_license" &&
                    modal.data &&
                    modal.data.front_license_link && (
                      <span
                        onClick={() => {
                          var elem = document.getElementById(props.id);

                          if (elem) {
                            elem.click();
                          }
                        }}
                      >
                        change
                      </span>
                    )) ||
                  (props.id === "back_license" &&
                    modal.data &&
                    modal.data.back_license_link && (
                      <span
                        onClick={() => {
                          var elem = document.getElementById(props.id);

                          if (elem) {
                            elem.click();
                          }
                        }}
                      >
                        change
                      </span>
                    )) || (
                    <span
                      onClick={() => {
                        var elem = document.getElementById(props.id);

                        if (elem) {
                          elem.click();
                        }
                      }}
                    >
                      {" "}
                      browse
                    </span>
                  )}
              </span>
            </>
          )}
          <input
            type="file"
            id={props.id}
            name={props.id}
            onBlur={props.handleBlur}
            {...getInputProps()}
            style={{ display: "none" }}
            multiple={false}
          />
        </div>
      )}

      {props.type === "upload_multiple" && (
        <div className={styles.upload} {...getRootProps()} onClick={() => {}}>
          {isDragActive ? (
            <>
              <div className={styles.uploadIcon}>
                <Icon image="arrow-down-circle" color="#d32426" size={20} />
              </div>
              <span>Drop your file</span>
            </>
          ) : (
            <>
              <div className={styles.uploadIcon}>
                <Icon image="upload" color="#d32426" size={20} />
              </div>
              <span>
                {document.getElementById(props.id) &&
                  document.getElementById(props.id).files[0] && (
                    <>
                      <span>
                        Attached:{" "}
                        {document.getElementById(props.id).files[0].name +
                          ", and others " +
                          (document.getElementById(props.id).files.length - 1)}
                      </span>
                      <br />
                    </>
                  )}
                Drag & drop or{" "}
                <span
                  onClick={() => {
                    var elem = document.getElementById(props.id);

                    if (elem) {
                      elem.click();
                    }
                  }}
                >
                  browse
                </span>
              </span>
            </>
          )}
          <input
            type="file"
            id={props.id}
            name={props.id}
            multiple
            onBlur={props.handleBlur}
            onChange={props.handleChange}
            {...getInputProps()}
            style={{ display: "none" }}
          />
        </div>
      )}

      {props.type === "select" && (
        <Field
          id={props.id}
          name={props.id}
          as="select"
          disabled={props.disabled}
          defaultValue={props.defaultValue}
          className={styles.inputDropdown}
          onChange={props.handleChange}
          onBlur={props.handleBlur}
          style={props.halfSize ? { width: "50%" } : { width: "100%" }}
        >
          {
            props.placeholder && (
              <option value="" disabled>
                {props.placeholder}
              </option>
            )
          }
          {props.options.map((option, index) => {
            return (
              <option value={option.value} label={option.label} key={index} />
            );
          })}
        </Field>
      )}

      {props.type === "state_select" && (
        <Field
          id={props.id}
          name={props.id}
          as="select"
          className={styles.inputDropdown}
          onChange={props.handleChange}
          onBlur={props.handleBlur}
          disabled={props.disabled}
          style={props.halfSize ? { width: "50%" } : { width: "100%" }}
        >
          {
            props.placeholder && (
              <option value="" disabled>
                {props.placeholder}
              </option>
            )
          }
          {props.options.map((option, index) => {
            return (
              <option value={option.value} label={option.label} key={index} />
            );
          })}
        </Field>
      )}

      {props.type === "search_select" && (
        <ReactSelect
          id={props.name}
          name={props.name}
          options={props.options}
          defaultValue={props.defaultValue}
          value={props.value}
          classNamePrefix="select"
          isSearchable
          onChange={(event) => props.handleChange(event)}
          required
          isDisabled={props.disabled}
          styles={{
            container: (baseStyles, state) => ({
              ...baseStyles,
              width: "100%",
              height: "50px",
              marginTop: "10px",
            }),
            control: (baseStyles, state) => ({
              ...baseStyles,
              width: "100%",
              height: "50px",
              border: "solid 1.5px #e0e0e0",
              borderRadius: "10px",
            }),
          }}
        />
      )}

      {props.type === "checkbox" && (
        <div className={styles.checkbox_container}>
          <Field
            id={props.id}
            type="checkbox"
            name={props.id}
            className={styles.checkbox_input}
            onChange={props.handleChange}
            disabled={props.disabled}
          />
          <label>{props.label}</label>
        </div>
      )}

      {props.showErrors && (
        <div
          className={styles.error}
          style={
            props.type === "date" || props.type === "state_select"
              ? props.errors
                ? { display: "flex" }
                : { display: "none" }
              : props.errors && props.touched
              ? { display: "flex" }
              : { display: "none" }
          }
        >
          <div className={styles.icon}>
            <Icon image="alert-circle" size={10} />
          </div>
          {props.errors}
        </div>
      )}
    </div>
  );
}
